import React from 'react';
// components
import FixedWithContainer from 'modules/emergencies/components/ui/containers/fixedWithContainer';
import Sticky from 'modules/emergencies/components/ui/sticky/sticky';
import NonSticky from 'modules/emergencies/components/ui/sticky/nonSticky';
import FilterViewsListTableHeaderRow from './rows/filterViewsListTableHeaderRow';
import FilterViewsListTableItemRow from './rows/filterViewsListTableItemRow';

const filterViewsListTable = ({ filterViewsListData }) => {
  const filterViews = filterViewsListData.filterViewsData.results.flat();
  const defaultFilterView = {
    id: -1,
    name: 'Default view',
  };
  const filterViewsWithDefault = [defaultFilterView, ...filterViews];

  return (
    <>
      <FixedWithContainer>
        <Sticky>
          <FilterViewsListTableHeaderRow />
        </Sticky>
        <NonSticky>
          {filterViewsWithDefault.map((filterView) => {
            return <FilterViewsListTableItemRow key={filterView.id} filterView={filterView} />;
          })}
        </NonSticky>
      </FixedWithContainer>
    </>
  );
};

export default filterViewsListTable;
